(function () {
  // Store most recent calculator context (from any calculator)
  window.__bfcalc_last = window.__bfcalc_last || null;

  // 1) Capture latest calculator update (already dispatched by calculators)
  window.addEventListener("bfcalc:updated", function (e) {
    if (!e || !e.detail) return;
    window.__bfcalc_last = e.detail;
  });

  // Helpers
  function safeText(el) {
    return el ? String(el.textContent || "").trim() : "";
  }

  function pushDL(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // 2) Track recommendation clicks (works for all reco grids)
  document.addEventListener("click", function (e) {
    // Only track clicks on product links inside reco cards
    var link = e.target && e.target.closest
      ? e.target.closest(".bf-fridge-card a[href]")
      : null;

    if (!link) return;

    var card = link.closest(".bf-fridge-card");
    if (!card) return;

    // Try to capture useful product fields
    var productId = card.getAttribute("data-product-id") || null;
    var productUrl = link.getAttribute("href") || null;

    // Prefer the visible product title inside the card
    var titleEl = card.querySelector(".bf-fridge-card__title");
    var productTitle = safeText(titleEl) || safeText(link) || null;

    // Position within currently visible cards (1-based)
    var grid = card.closest("[data-bfsolar-reco-grid], [data-bfdcdc-reco-grid], [data-bfbatt-reco-grid], [data-bffridge-reco-grid], .bf-fridge-recs__grid");
    var position = null;
    if (grid) {
      var visibleCards = Array.prototype.filter.call(
        grid.querySelectorAll(".bf-fridge-card"),
        function (c) { return !c.hidden; }
      );
      position = visibleCards.indexOf(card);
      position = position >= 0 ? (position + 1) : null;
    }

    var ctx = window.__bfcalc_last || {};

    pushDL({
      event: "bf_calculator_reco_click",

      // Calculator context (lets you segment clicks in GA Explore)
      calculator_type: ctx.calculator_type || null,
      recommendation_category: ctx.recommendation_category || null,
      recommendation_use_case: ctx.recommendation_use_case || null,
      recommendation_tier: ctx.recommendation_tier || null,

      // Clicked item
      product_id: productId,
      product_title: productTitle,
      product_url: productUrl,
      product_position: position,

      interaction_type: "click"
    });
  });
})();
